import {
  TABLE_OVERRIDES,
  BIG_QUERY_OPTIONS,
  FIELD_OVERRIDES,
  PARTITIONING,
} from 'app/playbook-editor/parameters/editor-panel/parameter/consts';

export default function togglePipelineVar(isExpanded, selectedOperation, name) {
  if (PIPELINE_VAR_INELIGIBLE_PARAMS.includes(name)) {
    return false;
  }

  return isExpanded && selectedOperation === 'params';
}

export const PIPELINE_VAR_INELIGIBLE_PARAMS = [
  'S_3',
  'GCS',
  'COMPRESSION',
  'OPT_OUT_SCHEMA_CREATION',
  'TLS',
  'BACKLOG_COUNT',
  'PROFILE_ID',
  'BATCH_SIZE',
  'PRIVATE_KEY',
  'BROKERS',
  'AUTHENTICATION (SASL)',
  'STAGE',
  TABLE_OVERRIDES,
  FIELD_OVERRIDES,
  PARTITIONING,
  BIG_QUERY_OPTIONS,
];
